export default "__VITE_ASSET__CqjjrlTh__"